import React, { useState, useEffect, useRef } from "react"
import { UFDate, UFInput } from "../../../components/Common/Fields/Input"
import { Col, Form, Row } from "reactstrap"
import resetIcon from "../../../assets/icons/reset.svg"
import { Controller, useForm } from "react-hook-form"
import ProductList from "../../../components/Common/chooseFields/productList"
import FinanceLedgersLi from "../../../components/Common/chooseFields/ledgers"
import { useSelector } from "react-redux"
import { isEmpty } from "lodash"
import moment from "moment"
import { DebounceInput } from "react-debounce-input"
import FinCostCenterLi from "../../../components/Common/chooseFields/costCenterFinLi"

const ProjectBillingFilter = ({
  handleSearchChange,
  handleProductChange,
  handleFinacialChange,
  productId,
  productName,
  resetData,
  handleDateChange,
  handleCacheClear,
}) => {
  const { fromData, toData, productData, search } = resetData || {}
  const { control, watch, reset, setValue } = useForm({
    defaultValues: {
      req_date: [moment().startOf("month").toDate(), moment().toDate()],
    },
  })
  const initialSearchSetRef = useRef(false)
  console.log(`productId chk :`, productId)

  const loggedUser = useSelector(state => state.Login.loggedUser)
  const [companyCheck, setCompanyCheck] = useState(false)
  const [finacialCheck, setfinacialCheck] = useState(true)
  const [startDate, setStartDate] = useState(
    moment().startOf("month").format("YYYY-MM-DD")
  )
  const [endDate, setEndDate] = useState(moment().format("YYYY-MM-DD"))

  useEffect(() => {
    if (productId) {
      setValue("cc_id", {
        label: `${productName}`,
        value: productId,
      })
      handleProductChange(productId)
    }
  }, [productId])

  const handleCCChange = data => {
    handleProductChange(data)
  }

  const handleRequestdate = () => {
    const statDate = watch("start_date")
    const enDate = watch("end_date")
    const fromDate = statDate ? moment(statDate).format("YYYY-MM-DD") : ""
    const toDate = enDate ? moment(enDate).format("YYYY-MM-DD") : ""
    handleDateChange(fromDate, toDate)
  }

  useEffect(() => {
    handleSearchChange(watch("search"))
  }, [watch("search")])
  const handleCache = () => {
    handleCacheClear(1)
  }
  const handleReset = () => {
    handleProductChange()
    handleFinacialChange(true)
    setfinacialCheck(true)
    handleDateChange()
    // handleCacheClear(1)
    reset({
      costcenter_id: null,
      cc_id: null,
      search: "",
      th_no: null,
      //   req_date: [moment().startOf("month").toDate(), moment().toDate()],
    })
    setStartDate(moment().startOf("month").format("YYYY-MM-DD"))
    setEndDate(moment().format("YYYY-MM-DD"))
  }

  const handleFinacialCheck = dt => {
    handleFinacialChange(!dt)
    setfinacialCheck(!dt)
  }

  useEffect(() => {
    setValue(
      "cc_id",
      productData
        ? { label: productData.label, value: productData.value }
        : null,
      { shouldValidate: false, shouldDirty: false }
    )
    setValue(
      "start_date",
      fromData ? moment(fromData, "YYYY-MM-DD").toDate() : null,
      { shouldValidate: false, shouldDirty: false }
    )
    setValue(
      "end_date",
      toData ? moment(toData, "YYYY-MM-DD").toDate() : null,
      { shouldValidate: false, shouldDirty: false }
    )
    // set initial search from prop only once (don't overwrite while user types)
    if (search && !initialSearchSetRef.current) {
      setValue("search", search, { shouldValidate: false, shouldDirty: false })
      initialSearchSetRef.current = true
    }
  }, [fromData, toData, productData, setValue, search])

  return (
    <div className="d-flex justify-content-between align-items-center my-2 me-2">
      <Form id="user-form" className="filter-wrapper">
        <Row className="mx-0">
          <Col sm={3} className="pe-1">
            <FinCostCenterLi
              control={control}
              placeholder="Select"
              name={"cc_id"}
              onSelectChange={e => handleCCChange(e)}
              excludeIdOne={true}
              type={"project"}
            />
          </Col>
          {/* <Col sm={3} className="pe-1">
            <UFDate
              control={control}
              placeholder="Date"
              name={"req_date"}
              mode="range"
              className="ufinput-dashboard"
              onDateChange={e => handleRequestdate(e)}
              defaultValue={[
                moment().startOf("month").toDate(),
                moment().toDate(),
              ]}
            />
          </Col> */}
          <Col sm={2} className="pe-1">
            <UFDate
              control={control}
              name={"start_date"}
              placeholder={"Start Date"}
              onDateChange={handleRequestdate}
              maxDate={toData ? toData : ""}
            />
          </Col>
          <Col sm={2} className="pe-1">
            <UFDate
              control={control}
              name={"end_date"}
              placeholder={"End Date"}
              onDateChange={handleRequestdate}
            />
          </Col>
        </Row>
      </Form>
      <div className="d-flex">
        <div
          className="export-div pointer me-2 reset-img"
          onClick={() => handleCache()}
          title="Clear Cache"
        >
          <img
            src={resetIcon}
            height={15}
            width={15}
            className=""
            alt="hard refresh"
          />
        </div>
        {/* <div
          className="export-div pointer me-2 ms-0 reset-img py-1"
          onClick={() => handleCache()}
        >
         
          Clear
        </div> */}
        <div
          className="export-div pointer me-2 ms-0 reset-img py-1"
          onClick={() => handleReset()}
        >
          <img
            src={resetIcon}
            height={15}
            width={15}
            className="me-2"
            alt="refresh"
          />{" "}
          Reset
        </div>
        {/* <Controller
          name="search"
          control={control}
          defaultValue=""
          render={({ field }) => (
            <DebounceInput
              {...field}
              placeholder="Search"
              className="search-input form-control"
              minLength={1}
              debounceTimeout={500}
              onChange={e => {
                field.onChange(e)
                handleSearchChange(e.target.value)
              }}
            />
          )}
        /> */}
        {/* <UFInput
          control={control}
          placeholder="Search"
          name={"search"}
          className={"search-input"}
        /> */}
      </div>
    </div>
  )
}

export default ProjectBillingFilter
